import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const ContentMasteryTestSpeechRateGauge = (props) => (
  <KpiChart
    title="Speech recognition difficulty"
    description="The number represents the average record button usage per item execution. The exercises which represent this number are: Presentation, Video Short, Pronunciation, Speech Practice, Unscramble Speech Recognition, Gap Fill, Single Choice Game, Phoneme and Vocabulary Kids."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 2, 3, 5]}
    stepSize={1}
    reverseColors={true}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

ContentMasteryTestSpeechRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  formatter: PropTypes.func.isRequired,
  onClickHistory: PropTypes.func,
};

export default ContentMasteryTestSpeechRateGauge;
